import { apiClientWithRefreshToken } from "@/api/apiClient";

async function DeleteUser(id: string) {
    return apiClientWithRefreshToken({
        url: `/users/${id}`,
        method: "DELETE",
    });
}

export default DeleteUser;
